export default __webpack_public_path__ + "static/char-s-53-zh-Hant-39b0e3d1031683daae5863d8a2080037.png";